module.exports = __webpack_public_path__ + "img/PERSONAS-1.9192d05c.png";